var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 32,
    viewBox: "0 0 200 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 6,
    y: 12,
    width: 2,
    height: 8,
    rx: 1,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 12,
    y: 9,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 18,
    y: 14,
    width: 2,
    height: 4,
    rx: 1,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 24,
    y: 8,
    width: 2,
    height: 16,
    rx: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 30,
    y: 9,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 36,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 42,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 48,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 54,
    y: 9,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 60,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 66,
    y: 8,
    width: 2,
    height: 16,
    rx: 1,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 72,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 78,
    y: 14,
    width: 2,
    height: 4,
    rx: 1,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 84,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 90,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 96,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 102,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 108,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 114,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 120,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 126,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 132,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 138,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 144,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 150,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 156,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 162,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 168,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 174,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 180,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 186,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 192,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 198,
    y: 15,
    width: 2,
    height: 2,
    rx: 1,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveform);
export default __webpack_public_path__ + "static/media/Waveform.b89b8f8d0623cd642a2873d1d547c021.svg";
export { ForwardRef as ReactComponent };